import React from "react";
import clsx from "clsx";
import RoomTypeBuilderErrors from "../RoomTypeBuilderErrors";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import I18n from "i18n-js";
import ErrorHelper from "../../Errors/ErrorHelper";
import NumberInput from "../../NumberInput/NumberInput";

class RoomTypeBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.autocomplete = null;
  }

  async componentDidMount() {
    this.autocomplete = await new google.maps.places.Autocomplete(document.getElementById('autocomplete'), { types: ['address'] });
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
  };

  componentDidUpdate() {
    if (this.refs.room_type_color) {
      $(this.refs.room_type_color).spectrum("set", this.props.color);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.refs.room_type_color && this.props.onColorChange) {
      $(this.refs.room_type_color).spectrum({
        allowEmpty: true,
        preferredFormat: "hex",
        cancelText: I18n.t("cancel"),
        chooseText: I18n.t("save"),
        showButtons: true,
        showInput: true,
        change: (color) => this.props.onColorChange(color.toHexString()),
        color: this.props.color,
        showPalette: true,
        palette: [
          [
            "#600",
            "#783f04",
            "#7f6000",
            "#274e13",
            "#0c343d",
            "#073763",
            "#20124d",
            "#4c1130",
          ],
          [
            "#900",
            "#b45f06",
            "#bf9000",
            "#38761d",
            "#134f5c",
            "#0b5394",
            "#351c75",
            "#741b47",
          ],
          [
            "#c00",
            "#e69138",
            "#f1c232",
            "#6aa84f",
            "#45818e",
            "#3d85c6",
            "#674ea7",
            "#a64d79",
          ],
          [
            "#e06666",
            "#f6b26b",
            "#ffd966",
            "#93c47d",
            "#76a5af",
            "#6fa8dc",
            "#8e7cc3",
            "#c27ba0",
          ],
          [
            "#ea9999",
            "#f9cb9c",
            "#ffe599",
            "#b6d7a8",
            "#a2c4c9",
            "#9fc5e8",
            "#b4a7d6",
            "#d5a6bd",
          ],
          [
            "#f4cccc",
            "#fce5cd",
            "#fff2cc",
            "#d9ead3",
            "#d0e0e3",
            "#cfe2f3",
            "#d9d2e9",
            "#ead1dc",
          ],
        ],
      });
    }
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-12">{this.renderGeneralForm()}</div>
        </div>
      </div>
    );
  }

  renderErrors() {
    var errors = RoomTypeBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        if (error == "must be greater than 0") {
          idx = idx + 1;
          return (
            <li style={{ textAlign: "left" }} key={idx}>
              <b>&#x2022;</b> {error}
            </li>
          );
        } else if (error == "is not a number") {
          idx = idx + 1;
          return (
            <li style={{ textAlign: "left" }} key={idx}>
              <b>&#x2022;</b> {error}
            </li>
          );
        } else {
          idx = idx + 1;
          return (
            <li key={idx}>
              <b>&#x2022;</b> {error}
            </li>
          );
        }
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = "";
    } else {
      var classname = "form-control";
    }
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      if (field === "maximum_occupancy" || field === "status") {
        classname = "form-control has-errors";
      } else {
        classname = classname + " has-errors";
      }
    }
    return classname;
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row" id="test">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t("code")}*`}</label>
              <input
                id="code"
                type="text"
                name="room_type[code]"
                maxLength="12"
                className={this.renderFieldClasses("code")}
                value={this.props.code || ""}
                onChange={this.props.onFieldChange}
              />
              {this.renderFieldErrors("code")}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t("name")}*`}</label>
              <input
                id="name"
                type="text"
                name="room_type[name]"
                className={this.renderFieldClasses("name")}
                value={this.props.name || ""}
                onChange={this.props.onFieldChange}
              />
              {this.renderFieldErrors("name")}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("status")}</label>
              <br />
              <select
                id="status"
                name="room_type[status]"
                value={this.props.status || ""}
                onChange={this.props.onFieldChange}
                className={this.renderFieldClasses("status", false)}
              >
                <option value="enabled">{I18n.t("enabled")}</option>
                <option value="disabled">{I18n.t("Disabled")}</option>
              </select>
              {this.renderFieldErrors("status")}
            </div>
          </div>
        </div>

        <hr />
        <div className="row">
     

          <div className="col-md-2">
            <div className="form-group">
              <label>
                {`${I18n.t("maximum_occupancy")}*`}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("maximum_occupancy_helper_text")}
                ></span>
              </label>
              <NumberSpinner
                id="maximum_occupancy"
                name="room_type[maximum_occupancy]"
                value={this.props.maximum_occupancy || ""}
                onChange={this.props.onFieldChange}
                hasError={this.renderFieldClasses("maximum_occupancy", true)}
              />
              {this.renderFieldErrors("maximum_occupancy")}
            </div>
          </div>

          <div className="col-md-2">
            <div className="form-group">
              <label>
                {I18n.t("room_size")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("room_size_helper_text")}
                ></span>
              </label>
              <div>
                <NumberInput
                  id={this.props.room_type_id}
                  name="room_size"
                  value={this.props.room_size || ""}
                  onChange={this.props.onFieldChange}
                  className="form-control room-size-input"
                  placeholder={I18n.t("eg_room_size")}
                  custom_style={{display: "inline-block", width: "60%"}} 

                />
                <select
                  id="room_size_unit"
                  name="room_type[room_size_unit]"
                  value={this.props.room_size_unit || ""}
                  onChange={this.props.onFieldChange}
                  className="form-control"
                  style={{ display: "inline-block", width: "40%" }}
                >
                  <option value="sq2">{I18n.t("sq2")}</option>
                  <option value="m2">{I18n.t("m2")}</option>
                </select>
              </div>
            </div>
          </div>

          <div className="col-md-2">
            <div className="form-group">
              <label>
                {I18n.t("housekeeping")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("housekeeping_status_helper_text")}
                ></span>
              </label>
              <br />
              <select
                id="housekeeping_status"
                name="room_type[housekeeping_status]"
                value={this.props.housekeeping_status || ""}
                onChange={this.props.onFieldChange}
                className="form-control"
              >
                <option value="enabled">{I18n.t("enabled")}</option>
                <option value="disabled">{I18n.t("Disabled")}</option>
              </select>
            </div>
          </div>
          
          { this.props.type_of_booking != "daily" 
              ?
            <div className="col-md-2">
              <div className="form-group">
                <label>{I18n.t("ota_channels")} {this.props.ru_id ? `(id:${this.props.ru_id})` : null} </label>
                <br />
                <select
                  id="ru_active"
                  name="room_type[ru_active]"
                  value={this.props.ru_active || ""}
                  onChange={this.props.onFieldChange}
                  className="form-control"
                >
                  <option value="enabled">{I18n.t("enabled")}</option>
                  <option value="disabled">{I18n.t("Disabled")}</option>
                </select>
              </div>
            </div>
              :
            null
          }
          
        </div>        

        <hr />
        {this.props.type_of_booking != "daily" 
          ?
          <div>
            <div>
              <label>{I18n.t("bed_types")}({I18n.t('sleeps')}) </label>
            </div>
            <br/>
            <div className={ErrorHelper.renderFieldClassesRow(
              "bed_types",
              this.props.errors
            )}>
              {this.renderBedTypes()}
            </div>
          </div>
          :
          null
        }
        

        <hr />

        <div className="row" id="test2">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t("description")}*{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("room_type_description_helper_text")}
                ></span>
              </label>
              <textarea
                name="room_type[description]"
                id="description"
                className={ErrorHelper.renderFieldClasses(
                  "description",
                  this.props.errors,
                  'form-control'
                )}
                rows={8}
                value={this.props.description || ""}
                onChange={this.props.onFieldChange}
              />
              <div style={{fontSize:"12px", paddingTop:"3px"}}>{`${this.props.description.length} ${I18n.t("characters").toLowerCase()}`}</div>
              {ErrorHelper.renderFieldErrors("description", this.props.errors)}
            </div>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{I18n.t("address_1")}*</label>
                  <input
                    id="autocomplete"
                    type="text"
                    // autoComplete="new-password"
                    className="form-control"
                    name="address_1"
                    onChange={this.props.onChange}
                    value={this.props.address_1 || ""}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>{I18n.t("address_2")}</label>
                  <input
                    type="text"
                    autoComplete="new-password"
                    className="form-control"
                    name="address_2"
                    onChange={this.props.onChange}
                    value={this.props.address_2 || ""}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>{I18n.t("city")}*</label>
                  <input
                    type="text"
                    autoComplete="new-password"
                    className="form-control"
                    name="city"
                    onChange={this.props.onChange}
                    value={this.props.city || ""}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>{I18n.t("state_province")}*</label>
                  <input
                    type="text"
                    autoComplete="new-password"
                    className="form-control"
                    name="state"
                    onChange={this.props.onChange}
                    value={this.props.state || ""}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>{I18n.t("postal_code")}</label>
                  <input
                    type="text"
                    autoComplete="new-password"
                    className={ErrorHelper.renderFieldClasses('postal_code', this.props.errors, 'form-control')}
                    name="postal_code"
                    onChange={this.props.onChange}
                    value={this.props.postal_code || ""}
                  />
                  {ErrorHelper.renderFieldErrors('postal_code', this.props.errors)}
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>{I18n.t("country")}</label>
                  <input
                    type="text"
                    autoComplete="new-password"
                    className="form-control"
                    name="country"
                    onChange={this.props.onChange}
                    value={this.props.country || ""}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>{I18n.t("licence_number")}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="licence_number"
                    onChange={this.props.onChange}
                    value={this.props.licence_number || ""}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  handlePlaceSelect = () => {
    let addressObject = this.autocomplete.getPlace()
    let address = addressObject.address_components
    for (let i = 0, ilen = address.length; i < ilen; i++) {
      for (let j = 0, jlen = address[i].types.length; j < jlen; j++) {
        if (address[i].types[j] === "street_number") {
          var street_number = address[i].long_name
        }
        if (address[i].types[j] === "route") {
          var route = address[i].long_name
        }
        if (address[i].types[j] === "locality") {
          var city = address[i].long_name
        }
        if (address[i].types[j] === "administrative_area_level_1") {
          var state_province = address[i].long_name
        }
        if (address[i].types[j] === "postal_code") {
          var postal_code = address[i].long_name
        }
        if (address[i].types[j] === "country") {
          var country = address[i].long_name
        }
      }
    }

    let objForState = {
      address_1: street_number ? `${street_number} ${route}` : route,
      city: city,
      state: state_province,
      country: country,
      postal_code: postal_code
    };

    this.props.onGeoSelectAddress(objForState);
  };

  renderBedTypes = () => {
    return this.props.ordered_bed_types.map((ordered_bed_type) => {
      const activeBedType = this.props.bed_types.find(bt => bt.bed_type_id == ordered_bed_type.id)

      // if (activeBedType) {

      // } else {
        return (
          <div key={ordered_bed_type.id} className="col-sm-3 pb-4">
            <input
              id={ordered_bed_type.id}
              type="checkbox"
              name="bed_type"
              onChange={this.props.changeBedType}
              checked={activeBedType ? true : false}
            />
            {/* <div className="labels"> */}
            <label className="ml-2">{ordered_bed_type.name}({ordered_bed_type.sleeps})</label>
              {/* <label className="ml-2 amenity-otas">{ordered_bed_type.sleeps}</label> */}
            {/* </div> */}
            <br />

            <div className="amenity-spinner">
              {activeBedType ?
                <NumberSpinner
                  id={activeBedType.bed_type_id}
                  name="bed_type"
                  value={activeBedType.count}
                  onChange={this.props.changeBedCount}
                  min={1}
                  max={999}
                />
                :
                null
              }
            </div>
          </div>
        );
      // };
    });
  };

  
}

export default RoomTypeBuilderGeneral;
